import React from 'react'
import '../styles/styles.css'
import '../styles/vendor.min.css'
import '../styles/custom.css'
import Header from './Header'
import Footer from './Footer'
const BasicLayout = (props) => {
  const arr = window.location.href.split('/')
  const host = arr[0] + '//' + arr[2]

  const link =
    (process.env.NODE_ENV === 'production'
      ? process.env.REACT_APP_AFIP_PROD_LOGOUT_URL
      : process.env.REACT_APP_AFIP_TEST_LOGOUT_URL) +
    host +
    '/ddjj/logout'

  return (
    <>
      <Header />

      <div className="container">
        <div>
          <a
            className={'btn-link btn'}
            style={{ marginTop: '50px', float: 'right' }}
            href={link}
          >
            Cerrar Sesión
          </a>
          <div style={{ clear: 'both' }}></div>
        </div>
        {props.children}
      </div>

      <Footer />
    </>
  )
}

export default BasicLayout
